import { render, staticRenderFns } from "./TokuteiInfo.vue?vue&type=template&id=047e7afd&scoped=true"
import script from "./TokuteiInfo.vue?vue&type=script&lang=js"
export * from "./TokuteiInfo.vue?vue&type=script&lang=js"
import style0 from "./TokuteiInfo.vue?vue&type=style&index=0&id=047e7afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e7afd",
  null
  
)

export default component.exports